import * as React from 'react';
import { getMylo } from '@src/app/login/selectors';
import { actionCreators } from '@src/app/user/actions';
import { connect } from 'react-redux';
import { RootState, Dispatch } from '@src/app/_redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Mylo from 'mylo-js';
import { parse } from 'query-string';
export interface MyloContinueProps {
  mylo: Mylo;
  accountNumber: string;
  postalCode: string;
  loginAccountNumberAction: any;
  loginPostalCodeAction: any;
}

export class MyloContinueForm extends React.Component<MyloContinueProps> {
  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    // this is needed to set up PKCE in the SDK
    await this.props.mylo.getPopupUrl();
    const tokens = await this.props.mylo.getTokens(false);
    if (tokens) {
      // set the account info into userState
      this.props.loginAccountNumberAction({payload: this.props.accountNumber});
      this.props.loginPostalCodeAction({payload: this.props.postalCode});

      if (window.opener) {
        window.opener.location.href = 
            `/auth/success/#access_token=${tokens.access_token}&id_token=${tokens.id_token}`; 
      } else {
        window.location.href = 
            `/auth/success/#access_token=${tokens.access_token}&id_token=${tokens.id_token}`; 
      }
    }
  }
  
  render() {
    return (
      <div className="mylo-view">

      <div>Click 
        <a href="#"
          onClick={() => window.location.href = '/login'}
          className=""
        >
          <FormattedMessage
            id="app.cancel"
            description="Cancel"
            defaultMessage=" here"
          />
        </a> if not redirected.
      </div>
    </div>);
  }
}

const mapStateToProps = (state: RootState, props) => {
  // get the account number and postal code props from the query string
  // base64 encoded value: accountNumber|postalCode
  const accountInfo = parse(props.location.search).ac;
  const decodedAccountInfo = atob(accountInfo).split('|');
  const accountNumberParm = decodedAccountInfo[0] || '';
  const postalCodeParm = decodedAccountInfo[1] || '';
  return {
    accountNumber: accountNumberParm,
    postalCode: postalCodeParm,
    mylo: getMylo(state, `/mylo/continue?ac=${accountInfo}`), 
  };
};
const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      loginAccountNumberAction: actionCreators.loginAccountNumber,
      loginPostalCodeAction: actionCreators.loginPostalCode,
    },
    dispatch,
  );

export const MyloContinue = connect(mapStateToProps, mapDispatchToProps)(MyloContinueForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/login/components/MyloContinue.tsx